import { render, staticRenderFns } from "./EvaluationService.vue?vue&type=template&id=4be41614&"
import script from "./EvaluationService.vue?vue&type=script&lang=js&"
export * from "./EvaluationService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports